// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"449f982e","145":"0a260a7c","176":"60668f63","229":"8043cbda","758":"e43e8201","761":"103535b9","795":"60668f63","863":"12de863c","958":"47ef1383"}[chunkId] + ".chunk.css";
};